import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import '@fortawesome/fontawesome-free/css/all.min.css';

import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
// Bundled Roboto (MUI): requires `npm install` so `@fontsource/roboto` exists under node_modules.
// import '@fontsource/roboto/300.css';
// import '@fontsource/roboto/400.css';
// import '@fontsource/roboto/400-italic.css';
// import '@fontsource/roboto/500.css';
// import '@fontsource/roboto/500-italic.css';
// import '@fontsource/roboto/700.css';
// import '@fontsource/roboto/700-italic.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter} from "react-router-dom";
import BlockEContextProvider from './context/BlockEContext';
import axios from 'axios';
import { getCsrfToken, CSRF_HEADER_NAME, syncCsrfFromResponse, purgeStoredCsrfIfCookieMode } from './utils/csrf';
import { AUTH_USE_HTTPONLY_COOKIE } from './config/authFlags';
import { purgeStoredJwtIfCookieMode } from './utils/authStorage';

if (AUTH_USE_HTTPONLY_COOKIE) {
  axios.defaults.withCredentials = true;
  purgeStoredJwtIfCookieMode();
  purgeStoredCsrfIfCookieMode();
}

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  if (window.location.protocol === 'http:') {
    console.warn('UPDES: App is loaded over HTTP. Use HTTPS in production to protect the auth token in transit.');
  }
}

// CSRF + cookie auth: send cookies; drop broken Bearer headers when token is not in JS
axios.interceptors.request.use((config) => {
  const csrf = getCsrfToken();
  if (csrf) {
    config.headers[CSRF_HEADER_NAME] = csrf;
  }
  if (AUTH_USE_HTTPONLY_COOKIE) {
    config.withCredentials = true;
    const h = config.headers || {};
    const a = h.Authorization || h.authorization;
    if (a && /Bearer\s*(undefined|null)?\s*$/i.test(String(a))) {
      delete h.Authorization;
      delete h.authorization;
    }
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    syncCsrfFromResponse(response);
    return response;
  },
  (error) => {
    if (error?.response) {
      syncCsrfFromResponse(error.response);
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <BlockEContextProvider>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
     
     </BlockEContextProvider>

);
reportWebVitals();
